export const wechatList = [
    {
        id: 1,
        name: '伯纳思科技',
        phone: '13032706522',
        content: '意向客户手机；微信在柏菁三星手机里；微信实名是柏菁；联通手机卡实名是柏菁'
    },
    {
        id: 2,
        name: 'A01 旅行社财务软件-旅当家',
        phone: '16671728310',
        content: '手机卡在橙色VIVO手机里；微信实名是赵莉；联通手机卡实名是柏菁'

    },
    {
        id: 3,
        name: 'A02 旅行社财务软件-旅当家',
        phone: '15871676792',
        content: '手机卡在黑色OPPO手机里；微信实名是柏菁；移动手机卡实名是柏菁'
    },
    {
        id: 4,
        name: 'A03 旅行社财务软件-旅当家',
        phone: '18062988838',
        content: '手机卡在橙色VIVO手机里；微信实名是赵莉；电信手机卡实名是柏菁'
    },
    {
        id: 5,
        name: 'A04 旅行社财务软件-旅当家',
        phone: '18162974180',
        content: '手机卡在黑色OPPO手机里；微信实名是柏菁；电信手机卡实名是柏菁'
    },
    {
        id: 6,
        name: 'A05 旅行社财务软件-旅当家',
        phone: '16671726932',
        content: '手机卡在黑色红米手机里；微信实名是王兰珍；联通手机卡实名是柏菁'
    },
    {
        id: 7,
        name: 'A06 旅行社财务软件-旅当家',
        phone: '13032706511',
        content: '手机卡在蓝色红米手机里；微信实名是赵莉；联通手机卡实名是柏菁'
    }
]